import * as yup from 'yup';

export const rowSchema = yup.object().shape({
  vendorId: yup.number().required(),
  quantity: yup
    .number()
    .test('quantity', 'More than 0', (val) => (val ? val > 0 : false))
    .required(),
});
